import { cn } from '@/utils'
import { PhotoEffectEyeButton } from '@/components/app/photos/photo-effects/components/photo-effect-eye-button'
import {
  FIGMA_TEXT_FOREGROUND,
  FIGMA_TEXT_PRIMARY,
  PEZ_BINARY_ROW_GRID,
  PEZ_BINARY_ROW_HEIGHT,
  PEZ_BINARY_ROW_PADDING_Y,
  PEZ_EFFECTS_LIST_WIDTH,
  PEZ_ROW_GAP,
  PEZ_ROW_PADDING_X,
} from '@/components/app/photos/photo-effects/constants/photo-effect-row-layout'

export interface PhotoEffectToggleRowProps {
  label: string
  active: boolean
  onToggle: () => void
  className?: string
}

/**
 * Binary effect row (WMPCM-9474 / Figma PEZ).
 * 295×44: eye 32 + left-aligned label.
 */
export function PhotoEffectToggleRow({
  label,
  active,
  onToggle,
  className,
}: PhotoEffectToggleRowProps) {
  const labelColor = active ? FIGMA_TEXT_PRIMARY : FIGMA_TEXT_FOREGROUND

  return (
    <div
      role="group"
      aria-label={label}
      className={cn('box-border shrink-0', className)}
      style={{
        width: PEZ_EFFECTS_LIST_WIDTH,
        height: PEZ_BINARY_ROW_HEIGHT,
        padding: `${PEZ_BINARY_ROW_PADDING_Y}px ${PEZ_ROW_PADDING_X}px`,
        display: 'grid',
        gridTemplateColumns: PEZ_BINARY_ROW_GRID,
        columnGap: PEZ_ROW_GAP,
        alignItems: 'center',
      }}
      data-photo-effect-row
    >
      <PhotoEffectEyeButton label={label} active={active} onToggle={onToggle} />

      <span
        className="min-w-0 truncate text-sm font-medium leading-[14px]"
        style={{ color: labelColor }}
        aria-hidden="true"
      >
        {label}
      </span>
    </div>
  )
}
